
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "@ember/test-waiters/-embroider-implicit-modules.js";
import "@glimmer/component/-embroider-implicit-modules.js";
import "ember-window-mock/-embroider-implicit-modules.js";
